import React, { Component } from "react";

import process from "../../../Assets/img/process_section.PNG";
import process_mobile from "../../../Assets/img/process_mobile.png";
import list1 from "../../../Assets/img/problem_solve.svg";
import list2 from "../../../Assets/img/google_searching.svg";
import list3 from "../../../Assets/img/image_reverse.svg";
import list4 from "../../../Assets/img/logical.svg";
import object2 from "../../../Assets/img/OBJECTS (2).svg";

class About_puzzled extends Component {

  constructor(props) {
    super(props);
    this.state = {
      validation_alert : false,
      validation_error : false,
      validation_blank : false,
    };
  }
 
  
  render() {
    return (
      <div className="about">
        <div className="">
        <div className="process_img d-xl-block d-lg-block d-md-block d-sm-none d-none">
          <img src={process} alt="" />
        </div>

        <div className="process_img d-xl-none d-lg-none d-md-none d-sm-block d-block">
          <img src={process_mobile} alt="" />
        </div>

        <div className="container how-to pt-5 pb-5">
          <div className="row">
            <div className="col-xl-6 col-lg-6 col-md-12 col-12">
              <h3 className="mb-4">How to play</h3>
          <h4 className="mb-0">Attention to Detail</h4>
          <p>
            Clearly observe and study every element in each level. Everything is there for a reason. 
          </p>

          <h4 className="mb-0 pt-3">Google is your Best Friend</h4>
          <p>
            Google is always a good idea. Make sure you look up any clues, as this will often help you get closer to the answer.
          </p>
          <h4 className="mb-0 pt-3">Crack the Level</h4>
          <p>
            There is no limit on the number of attempts. So keep guessing and keep solving.
          </p>

          <h4 className="mb-0 pt-3">Hall of Fame</h4>
          <p>
            Complete all levels and get on to our coveted Hall of Fame. 
          </p>
         </div>
            <div className="col-xl-6 col-lg-6 col-md-12 col-12">
              <img src={object2} className="left-object" alt="" />
            </div>
          </div>
        </div>

        <div className="container-fluid bg-base">
          <div className="container">
            <div className="row">
              <div className="col pl-0 pr-0">
                <div className="card card-body border-0 o-hidden mb-0 text-light signup_now">
                  <div className="position-relative flex-column flex-md-row align-items-center">
                    <div className="h3 text-center mb-md-0">
                      <span>Are you up for the challenge ?</span> Sign up now and
                      start cracking!  <a href="/register" className="btn btn-lg btn-yellow ml-5">
                      REGISTER
                    </a>
                    </div>
                    
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <section className="skill-Area">
          <div className="container pt-5 pb-5">
            <div className="row justify-content-center text-center mb-6">
              <div className="col-xl-8 col-lg-9">
                <h2 className="display-4 mx-xl-6">SKILLS REQUIRED</h2>
              </div>
            </div>
            <div className="row text-center skills_required">
              <div className="col-md-3 col-lg-3 col-6 mb-4 mb-lg-0">
                <img src={list1} alt="" /> <br/>
                <span> Problem <br/> Solving </span> 
              </div>
              <div className="col-md-3 col-lg-3 col-6 mb-4 mb-lg-0">
                <img src={list2} alt="" /> <br/>
                <span> Google <br/> Searching </span>
              </div>
              <div className="col-md-3 col-lg-3 col-6 mb-4 mb-lg-0">
                <img src={list3} alt="" /> <br/>
                <span> Image Reverse <br/> Search </span>
              </div>
              <div className="col-md-3 col-lg-3 col-6 mb-4 mb-lg-0">
                <img src={list4} alt="" /> <br/>
                <span> Logical <br/> Reasoning </span>
              </div>
            </div>
          </div>
        </section>
        

        </div>  
      </div>
    );
  }
}

export default About_puzzled;
